export default __webpack_public_path__ + "static/media/profile-child.e3ff8d8d.svg";